<template>
    <el-card shadow="never">
        <div class="header">
          <el-breadcrumb class="breadcrumb" separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">工作台</el-breadcrumb-item>
            <el-breadcrumb-item>竞投广告</el-breadcrumb-item>
          </el-breadcrumb>
          <el-button type="primary" class="editbtn" @click="addshow">创建竞投</el-button>
        </div>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
        <el-row :gutter="16">
            <el-col :span="6">
              <div class="statistic-card">
                <el-statistic :value="98500">
                  <template #title>
                    <div style="display: inline-flex; align-items: center">
                      目前竞投积分
                    </div>
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <el-col :span="6">
              <div class="statistic-card">
                <el-statistic :value="693700">
                  <template #title>
                    <div style="display: inline-flex; align-items: center">
                      参与人数
                    </div>
                  </template>
                </el-statistic>
              </div>
            </el-col>
            <el-col :span="6">
                <div class="statistic-card">
                  <el-statistic :value="693700">
                    <template #title>
                      <div style="display: inline-flex; align-items: center">
                        开始时间
                      </div>
                    </template>
                  </el-statistic>
                </div>
              </el-col>
            <el-col :span="6">
                <div class="statistic-card">
                    <el-countdown format="DD [days] HH:mm:ss" :value="value2">
                        <template #title>
                          <div style="display: inline-flex; align-items: center">
                            剩余时间
                          </div>
                        </template>
                    </el-countdown>
                </div>
            </el-col>
        </el-row>
    </el-card>
    <el-card shadow="never" style="margin-top:20px">
      <div class="search-box">竞投列表</div>
        <el-table row-key="id" v-loading="baseData.loading" border :data="tableData.data" style="width: 100%;margin-top: 10px;">
          <el-table-column prop="id" label="ID" width="60"/>
          <el-table-column prop="company" label="中标公司"/>
          <el-table-column prop="point" label="目前积分" width="100"/>
          <el-table-column prop="leastPoint" label="最低竞投积分" width="110"/>
          <el-table-column prop="targetPoint" label="目标积分" width="100"/>
          <el-table-column prop="remark" label="备注"/>
          <el-table-column prop="startTime" label="开始时间" width="180"/>
          <el-table-column prop="stopTime" label="截至投票时间" width="180"/>
          <el-table-column prop="pushTime" label="公布时间" width="180"/>
          <el-table-column prop="endTime" label="结束时间" width="200"/>
          <el-table-column label="状态" width="100">
            <template #default="scope">
                <el-switch
                  size="large"
                  @change="changeStatus(scope.row.id,scope.row.status)"
                  v-model="scope.row.status"
                  inline-prompt
                  active-text="显示"
                  inactive-text="不显示"
                  />
            </template>
          </el-table-column>
          <el-table-column fixed="right" label="操作" width="140" >
            <template #default="scope">
              <el-popconfirm
                confirm-button-text="Yes"
                cancel-button-text="No"
                title="确认是否删除?"
                @confirm="del(scope.row.id)"
              >
                <template #reference>
                  <el-button size="small" type="danger">删除</el-button>
                </template>
              </el-popconfirm>

            </template>
          </el-table-column>
        </el-table>
        
        <div class="pagestyle">
          <el-pagination
            v-model:current-page="searchForm.page"
            v-model:page-size="searchForm.limit"
            layout="sizes, prev, pager, next"
            :total="tableData.total"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          />
        </div>
    </el-card>

    <el-dialog v-model="baseData.biddingbox" title="添加竞投" width="500">
        <el-form :model="biddingform" label-width="120px">
          <el-form-item label="开始时间">
            <el-date-picker
                v-model="biddingform.startTime"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="截至投票时间">
            <el-date-picker
                v-model="biddingform.stopTime"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="公布时间">
            <el-date-picker
                v-model="biddingform.pushTime"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="结束时间">
            <el-date-picker
                v-model="biddingform.endTime"
                type="datetime"
                placeholder=""
                format="YYYY-MM-DD HH:mm:ss"
                value-format="YYYY-MM-DD HH:mm:ss"
            />
          </el-form-item>
          <el-form-item label="最低竞投积分">
            <el-input-number v-model="biddingform.leastPoint" :min="1" />
          </el-form-item>
          <el-form-item label="目标积分">
            <el-input-number v-model="biddingform.targetPoint" :min="1" />
          </el-form-item>
          <el-form-item label="状态">
            <el-switch
              size="large"
              v-model="biddingform.status"
              inline-prompt
              active-text="显示"
              inactive-text="不显示"
              />
          </el-form-item>
        </el-form>
        <template #footer>
          <div class="dialog-footer">
            <el-button @click="baseData.biddingbox = false">取消</el-button>
            <el-button type="primary" @click="add">
              提交
            </el-button>
          </div>
        </template>
    </el-dialog>
  </template>
  <script lang="ts" setup>
  import { reactive, onMounted, ref} from 'vue'
  import { ElMessage, ElLoading } from 'element-plus'
  import dayjs from 'dayjs'
  import api from '@/api/index'
  const value2 = ref(dayjs().add(1, 'month').startOf('month'))
  const searchForm = reactive({
    limit:10,
    page:1,
  })
  const baseData = reactive({
    loading:false,
    title:'',
    biddingbox:false,
  })
  const tableData:any = reactive({
    data:[],
    total:0,
  })
  const biddingform = reactive({
    id:'',
    startTime:'',
    stopTime:'',
    pushTime:'',
    endTime:'',
    leastPoint:100,
    targetPoint: 0,
    status: "true",
  })
  const addshow = () => {
    baseData.biddingbox = true
    biddingform.id = ''
    biddingform.startTime = ''
    biddingform.stopTime = ''
    biddingform.pushTime = ''
    biddingform.endTime = ''
    biddingform.leastPoint = 100
    biddingform.targetPoint = 0
    biddingform.status = "true"
  }
  const add = () => {
    baseData.loading = true
    api.biddingApi.add(biddingform).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        baseData.biddingbox = false
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const handleSizeChange = (val:number) => {
    searchForm.limit = val
    searchForm.page = 1
    getList()
  }
  const handleCurrentChange = (val:any) => {
    searchForm.page = val
    getList()
  }
  const getList = () => {
    baseData.loading = true
    api.biddingApi.list(searchForm).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        for(var i in res.data.list){
          res.data.list[i].status = res.data.list[i].status==1?true:false
        }
        tableData.data = res.data.list
        tableData.total = res.data.total
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const getNowBidding = () => {
    api.biddingApi.getNowBidding().then((res:any)=>{
      if(res.code==200){
        console.log(res.data)
      }else{
        baseData.title = '暂无'
      }
    })
  }
  const changeStatus = (id:number,status:number) => {
    baseData.loading = true
    api.biddingApi.changeStatus({id:id,status:status}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  const del = (id:number) => {
    baseData.loading = true
    api.biddingApi.del({id:id}).then((res:any)=>{
      baseData.loading = false
      if(res.code==200){
        ElMessage({
          message: res.message,
          type: 'success',
        })
        getList()
      }else{
        ElMessage.error(res.message)
      }
    })
  }
  onMounted(() => {
    getList()
    getNowBidding()
  })
  </script>
  <style>
  .statistic-card {
    height: 100%;
    padding: 20px;
    border-radius: 4px;
    background-color: var(--el-bg-color-overlay);
  }
</style>